import request from 'sb-request'
import { reducers } from 'redux/core'
import actions from 'redux/actions'
import { constants, object } from 'common/helpers'
import { modifyFlashSale } from 'common/helpers/modifiers/modifyResponse'
import { flashSaleQuery } from 'common/queries'

// import mock from './mock'


const fetch = () =>
  request.post(`graphql?name=flashSale`, {
    body: {
      query: `{
        ${flashSaleQuery}
      }`,
    },
    modifyResult: (data) => {
      const flashSale = object.get(data, 'flashSale', {})

      return modifyFlashSale(flashSale)
    },
  })
    .then((result) => {
      reducers.view.flashSaleBundlePage.set(result)

      return result
    })

const fetchTimer = () =>
  request.post(`graphql?name=flashSaleTimer`, {
    body: {
      query: `{
        flashSale {
          timeLeft
        }
      }`,
    },
    modifyResult: (data) => object.get(data, 'flashSale.timeLeft', 0),
  })
    .then((timeLeft) => {
      reducers.view.flashSaleBundlePage.set({ timeLeft })

      return timeLeft
    }, () => 0)

const setExpired = () => reducers.view.flashSaleBundlePage.setExpired(true)

let flashSaleTimeout

const setTimerForCart = () => {
  fetchTimer()
    .then((timeLeft) => {
      flashSaleTimeout = setTimeout(() => {
        actions.models.cart.fetch()
      }, timeLeft)
    })
}

const handleCartUpdate = ({ isFlashSaleRemoved, isFlashSaleExist }) => {
  clearTimeout(flashSaleTimeout)

  if (isFlashSaleRemoved) {
    actions.models.modals.open(constants.modals.humble.FlashSaleExpired)
  }
  else if (isFlashSaleExist) {
    setTimerForCart()
  }
}

const setIsFetched = (isFetched) => reducers.view.flashSaleBundlePage.setIsFetched(isFetched)

export default {
  fetch,
  setExpired,
  setTimerForCart,
  handleCartUpdate,
  setIsFetched,
}
